import * as yup from "yup";

export const labOperatorSchema = ({ requirePassword = false }) => {
  const schemaShape = {
    firstName: yup
      .string()
      .required("First Name is required")
      .label("First Name"),

    lastName: yup.string().label("Last Name"),
    email: yup
      .string()
      .email("Invalid email")
      .required("Email is required")
      .label("Email"),
    phone: yup
      .string()
      .required("Phone Number is required")
      .matches(/^[0-9]+$/, "Please enter valid contact number")
      .min(10, "Phone number must be 10 digits")
      .max(10, "Phone number must be 10 digits")
      .label("Phone Number"),
  };
  if (requirePassword) {
    schemaShape.password = yup
      .string()
      .required("Password is required")
      .label("Password");
  }
  return yup.object().shape(schemaShape);
};
